import React from 'react';

import TopLeaderboardSlider from '../TopLeaderboardSlider';
import TopUserCard from '../TopUserCard';

import s from './style.module.scss';

interface ITopLeaderboardProps {
  topData: any[];
  currency?: string;
  sponsor?: any;
}

const TopLeaderboard = ({
  topData,
  currency = '$',
  sponsor,
}: ITopLeaderboardProps) => {
  if (topData.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={s.root__desktop}>
        <div className={s.pedestal}>
          <div className={s.pedestal__content}>
            <div className={s.pedestal__rankings}>
              <TopUserCard
                type="second"
                user={topData[1]}
                currency={currency}
                sponsor={sponsor}
              />
              <TopUserCard
                type="first"
                user={topData[0]}
                currency={currency}
                sponsor={sponsor}
              />
              <TopUserCard
                type="third"
                user={topData[2]}
                currency={currency}
                sponsor={sponsor}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={s.root__mobile}>
        <TopLeaderboardSlider
          data={topData}
          sponsor={sponsor}
          currency={currency}
        />
      </div>
    </div>
  );
};

export default TopLeaderboard;
